const drivers = {
  drivers: 'Conductores',

  createNew: 'Nuevo',

  headerButtons: {
    create: {
      createBtn: 'Crear',
    },

    import: 'Importar',
  },

  import: {
    title: 'Carga de conductores',
  },

  toast: {
    error: {
      badResponse: '[Conductor] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  table: {
    headers: {
      displayName: 'Nombre',
      name: 'Nombre',
      driverStatus: 'Estado',
      email: 'Correo electrónico',
      vehicle: 'Vehículo',
      phoneNumber: 'Número de teléfono',
      address: 'Dirección',
      firstTripDistance: 'Distancia máxima del 1er viaje',
      action: 'Acción',
      attributes: 'Atributos',
      locations: 'Ubicaciones',
      areas: 'Zonas',
      excludedProfiles: 'Perfiles Excluidos',
    },
    statusOptions: {
      online: 'En línea',
      offline: 'Sin conexión',
      break: 'Descanso',
      enRoute: 'En ruta',
      suspended: 'Suspendido',
    },
    viewOptions: {
      showSuspended: 'Mostrar suspendido',
      showUnsuspended: 'Mostrar sin colgar',
    },
    filters: {
      status: 'Estado',
      vehicles: 'Vehículos',
      areas: 'Zonas',
      services: 'Servicios',
      suppliers: 'Proveedores',
      attributes: 'Atributos',
      locations: 'Ubicaciones',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    submit: {
      success: 'El conductor ha sido creado correctamente',
      error: 'No se pudo crear el conductor debido a un error interno del servidor',
    },
  },

  update: {
    submit: {
      success: 'El conductor se actualizó correctamente',
      error: 'No se pudo actualizar el conductor debido a un error interno del servidor',
    },
    formTabs: {
      informationTab: 'Información',
      notesTab: 'Notas',
      historyTab: 'Historia',
      reservationPreferencesTab: 'Preferencias de Reservación',
    },
    toast: {
      toastResetSuccess: 'El correo electrónico para restablecer la contraseña se ha enviado correctamente.',
      toastError: 'Algo salió mal, inténtelo de nuevo.',
      toastRemoveDriverSuccess: 'Conductor eliminado correctamente',
    },
    driverStatusOptions: {
      activate: 'Reactivar',
      deactivate: 'Suspender',
      statusActive: 'Activo',
      statusInactive: 'Inactiva',
      statusOffline: 'Sin conexión',
      statusOnline: 'En línea',
      statusEnRoute: 'En ruta',
      statusBreak: 'Descanso',
      popUpOptions: {
        popupTitleActive: 'Suspender conductor',
        popupTitleDeactivation: 'Retirar la suspensión del conductor',
        popupTitleUnsuspend: 'Motivo de remover suspensión',
        popupSubTitleDeactivation: 'Selecciona el motivo de la suspensión',
        popupActionActive: 'Retirar la suspensión del conductor',
        popupActionDeactivate: 'Suspender conductor',
      },
    },
    modalRemoveConfirm: {
      header: '¡Advertencia!',
      body: '¿Está seguro de que desea eliminar este conductor?',
      confirmBtn: 'Eliminar',
    },
  },
  deleteModal: {
    header: 'Eliminar conductores',
    body: 'Está a punto de eliminar {{num}} conductores.',
    success: 'Los conductores se eliminaron correctamente',
  },

  forms: {
    header: {
      createDriver: {
        title: 'Crear',
      },

      updateDriver: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      personalDetails: {
        header: 'Detalles personales',
        fields: {
          firstName: 'Nombre',
          lastName: 'Apellido',
          name: 'Nombre para mostrar',
          phone: 'NÚMERO DE TELÉFONO',
          email: 'Dirección de correo electrónico',
          password: 'Contraseña',
        },
      },
      areaSettings: {
        header: 'Configuraciones de zona',
        fields: {
          areas: 'Zonas',
          mode: 'Modo',
          priority: 'Prioridad',
          modeOptions: {
            allStops: 'Todas las Paradas',
            firstPickDrop: 'Primera Recogida / Última Entrega',
            legAOrigin: 'Origen del Tramo A',
          },
          priorityOptions: {
            low: 'Bajo',
            medium: 'Medio',
            high: 'Alto',
            strict: 'Estricto',
          },
        },
      },
      locationsSettings: {
        header: 'Configuraciones de Ubicaciones',
        fields: {
          locations: 'Ubicaciones',
          enableInBetweenRides: 'Habilitar Viajes Intermedios',
        },
      },
      vehicles: {
        header: 'Vehículos asignados',
        fields: {
          available: 'Vehículos disponibles',
          current: 'Vehículo actual',
        },
      },
      address: {
        header: 'Dirección de inicio',
        fields: {
          mainAddress: 'Dirección principal',
          firstTripDistance: 'Distancia máxima del 1er viaje',
          alt: 'Dirección alternativa',
        },
      },
      settings: {
        header: 'Configuraciones adicionales',
        fields: {
          services: 'Servicios',
          areas: 'Zonas',
          externalId: 'ID externo',
        },
      },
      supplier: {
        header: 'Proveedores',
        fields: {
          suppliers: 'Proveedores',
        },
      },
      allowSharedRides: {
        header: 'Permitir viajes compartidos',
        fields: {
          allowSharedRides: 'Permitir viajes compartidos',
        },
      },
      attributes: {
        header: 'Atributos',
      },
      excludedProfiles: {
        header: 'Perfiles Excluidos',
        dualList: {
          profilesList: {
            header: 'Lista de Perfiles',
          },
          excludedList: {
            header: 'Perfiles Excluidos',
          },
        },
      },
      buttons: {
        btnResetPassword: 'Restablecer contraseña',
        btnDelete: 'Eliminar',
      },
    },
  },
};

export default drivers;
